module.exports = __webpack_public_path__ + "static/media/avedorekort-v5.49a088f5.jpg";